const ufeApi = require('services/api/ufeApi');
const urlUtils = require('utils/Url');
const { handleSEOForCanada } = require('components/LegacyCatalog/utils');

// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+Nth+Level+Category+API

function getNthLevelCategory(options) {
    const {
        catalogId,
        ...opts
    } = options;
    const catalogService = Sephora.Util.InflatorComps.services.CatalogService;
    let url = `/api/catalog/categories/${catalogId}/products`;

    const constructorSessionID = !!global.ConstructorioTracker && global.ConstructorioTracker.getSessionID();
    const constructorClientID = !!global.ConstructorioTracker && global.ConstructorioTracker.getClientID();
    const isNLPCatalog = catalogService && catalogService.isNLPCatalog();
    const isNLPInstrumentationEnabled = Sephora.configurationSettings.isNLPInstrumentationEnabled;
    const getRefinement = function (){
        if (opts.ref && opts.ref.split(',').length) {
            opts.ref.split(',').forEach(refinement => url += `&ref=${refinement}`);
            delete opts.ref;
        }
    };

    if (isNLPInstrumentationEnabled){
        if (isNLPCatalog && constructorSessionID && constructorClientID) {
            url = url + `?constructorSessionID=${constructorSessionID}&constructorClientID=${constructorClientID}&targetSearchEngine=${catalogService.catalogEngine}`;
            getRefinement();
        }
    } else {
        url = url + `?targetSearchEngine=${catalogService.catalogEngine}`;
        getRefinement();
    }

    if (Object.keys(opts).length) {
        url += (isNLPCatalog ? '&' : '?') + urlUtils.makeQueryString(opts);
    }

    return ufeApi.makeRequest(url, { method: 'GET' }).
        then(data => {
            if (data.errorCode) {
                return Promise.reject(data);
            } else {
                Sephora.Util.InflatorComps.services.CatalogService.catalogEngine = data.responseSource;
                return handleSEOForCanada(data);
            }
        });
}

module.exports = { getNthLevelCategory };
